import { Action } from '@ngrx/store';
import { ServiceGroupCategory } from '@quorum/models/xs-resource';
import { ServiceGroupCategoryQueryParameters } from '@quorum/models/xs-query';

export const GET_SERVICE_GROUP_CATEGORIES_FROM_SERVER = '[CRM] Get Service Group Categories From Server';
export class GetServiceGroupCategoriesFromServer implements Action {
  readonly feature = 'svc';
  readonly type = GET_SERVICE_GROUP_CATEGORIES_FROM_SERVER;
  readonly triggerStorageSync = false;
  constructor(public payload: ServiceGroupCategoryQueryParameters) {}
}

export const GET_SERVICE_GROUP_CATEGORIES_FROM_SERVER_SUCCESS =
  '[CRM] Get Service Group Categories From Server Success';
export class GetServiceGroupCategoriesFromServerSuccess implements Action {
  readonly feature = 'svc';
  readonly type = GET_SERVICE_GROUP_CATEGORIES_FROM_SERVER_SUCCESS;
  readonly triggerStorageSync = true;
  constructor(public payload: { serviceGroupCategories: ServiceGroupCategory[] }) {}
}

export const GET_SERVICE_GROUP_CATEGORIES_FROM_SERVER_FAILURE =
  '[CRM] Get Service Group Categories From Server Failure';
export class GetServiceGroupCategoriesFromServerFailure implements Action {
  readonly feature = 'svc';
  readonly type = GET_SERVICE_GROUP_CATEGORIES_FROM_SERVER_FAILURE;
  readonly triggerStorageSync = false;
  constructor(public payload: { error: any }) {}
}

export type ServiceGroupCategoriesAction =
  | GetServiceGroupCategoriesFromServer
  | GetServiceGroupCategoriesFromServerSuccess
  | GetServiceGroupCategoriesFromServerFailure;
